// actionTypes
import { actionTypes } from 'src/@settings/actionTypes';
// resolvers
import { fetchAircraftFuelMappings } from 'src/@settings/resolvers';
// client
import ApolloClient from 'apollo-client';

export const getAircraftFuelMappings = (client: ApolloClient<object>, dispatcher: any, scenarioIds: number[]) => {
  dispatcher({ type: actionTypes.AIRCRAFT_FUEL_MAPPINGS_LOADING });
  fetchAircraftFuelMappings(client, scenarioIds)
    .then((data: any) => {
      dispatcher({ type: actionTypes.GET_AIRCRAFT_FUEL_MAPPINGS, aircraftFuelMappings: data });
    })
    .catch(error => {
      console.error(error);
      dispatcher({ type: actionTypes.AIRCRAFT_FUEL_MAPPINGS_LOADING });
    });
};